import axios from 'axios';

export const imageUtils = {
    cropRotatedRectangle(image, cx, cy, width, height, degrees) {
        // 1. Create a dynamic canvas matching the target cropped dimensions
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');

        // 2. Move the context origin to the center of our new canvas
        ctx.translate(width / 2, height / 2);
        ctx.scale(1, -1);

        // 3. Rotate the canvas context (convert degrees to radians)
        const radians = (degrees * Math.PI) / 180;
        ctx.rotate(-radians);

        // 4. Draw the original image shifting it back by the region's center
        // This lines up the rotated rectangle perfectly with the canvas boundary
        ctx.drawImage(
            image,
            -cx, // Shift X relative to original image center
            -cy  // Shift Y relative to original image center
        );

        // 5. Export the cropped area
        return canvas.toDataURL('image/jpeg', 0.9);
    },

    async getBase64FromImageUrl(imageUrl) {
        const headers = {};
        if (imageUrl.includes(".amazonaws.com")) {
            headers["Cache-Control"] = "no-cache";
        }
        const response = await axios.get(imageUrl, { responseType: 'blob', headers: headers });
        const blob = new Blob([response.data], { type: 'image/jpeg' });
        return URL.createObjectURL(blob);
    },

    async getBase64FromImageUrl2(imageUrl) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', imageUrl, true);
            xhr.responseType = 'blob';
            xhr.onload = () => {
                const blob = xhr.response;
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.onerror = () => {
                    reject(new Error('imageUtils.getBase64FromImageUrl: failed to read image'));
                };
                reader.readAsDataURL(blob);
            }
            xhr.send();
        })
    },
}